import script from "./StandardCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardCalculator.vue?vue&type=script&setup=true&lang=js"

import "./StandardCalculator.vue?vue&type=style&index=0&id=1da4b52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da4b52e"]])

export default __exports__